import React, { useEffect, useRef, useState } from 'react';
import Layout from '../../components/layout';
import Header from '../../components/header';
import { URLS } from '../../_config';
import Icon from '../../components/icons';
import { AgGridReact } from 'ag-grid-react';
import { data, useLocation, useNavigate, useParams } from 'react-router-dom';
import Drawer from '../../components/Drawer';
import CreateAssets from './_components/createChecklist';
import { Dropdown, Menu } from '../../components/Dropdown';
import Button from '../../components/elements/button';
import { useAssetsApi } from '../../store/api/hooks/assetsApiHook';
import Search from '../../components/search';
import moment from 'moment';
import { statusChangeDataType } from '../../_common/types';
import { useDialog } from '../../store/api/hooks/dialogHook';
import toast from 'react-hot-toast';
import { DATE_FORMAT, PAGE_SIZE } from '../../_common/constant';
import Pagination from '../../components/pagination';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { downloadExcel, downloadPDF, getPermissionInfo, showLocalDate } from '../../_common/functions';
import Loader from '../../components/loader';
import { filterConfigType } from '../../_config/types';
import Filters from '../../components/filters';
import { useAssestCategoriesSelector, useAssestClassificationsSelector, useAssestDepartmentsSelector, useAssestGroupsSelector, useAssestStatuesSelector, useAssestSubGroupsSelector, useAssestTypesSelector } from '../../store/selectors/masterSelector';
import { useFacilitiesApi } from '../../store/api/hooks/facilitiesApiHook';
import { titleCell } from '../../components/elements/function';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FindAssetsModal from './_components/findAssets.modal';
import { useChecklistApi } from '../../store/api/hooks/checklistApiHook';
import SignatureInput from '../../components/elements/form/signature';
import ChecklistPreviewModal from './_components/checklistPreview.modal';
import { useUserSelector } from '../../store/selectors/userSelector';


const ChecklistFormCreate: React.FC = () => {
    const location = useLocation();
    const loggedinuser: any = useUserSelector();
    const checklistAPI = useChecklistApi();
    const navigate = useNavigate();
    const params = useParams();

    const [gridApi, setGridApi] = useState<any>(null);
    const [gridColumnApi, setGridColumnApi] = useState<any>(null);
    const [selectedAssets, setSelectedAssets] = useState<any>([]);
    const [checklistName, setChecklistName] = useState<any>([]);

    const [assetInfoShow, setAssetInfoShow] = useState<boolean>(false);
    const [showLoader, setShowLoader] = useState<boolean>(false);

    const columnDefs = [
        { headerName: 'Asset ID', field: 'assetCode', headerClass: 'bg-[#f0f0f0]', },
        {
            headerName: 'Asset Name ', field: 'name', headerClass: 'bg-[#f0f0f0]',
            cellRenderer: (data: any) => {
                return (
                    <p className='hover:text-primary font-semibold cursor-pointer' title={data.value}>{data.value}</p>
                )
            }
        },
        { headerName: 'Category', field: 'categoryName', headerClass: 'bg-[#f0f0f0]', cellRenderer: titleCell },
        { headerName: 'Facility Name', field: 'facilityName', headerClass: 'bg-[#f0f0f0]', flex: 1, cellRenderer: titleCell },
        { headerName: 'Status', field: 'statusName', headerClass: 'bg-[#f0f0f0]', width: 120, cellRenderer: titleCell },

        {
            headerName: "Actions",
            field: "actions",
            headerClass: 'bg-[#f0f0f0] text-center',
            width: 90,

            cellRenderer: (params: any) => {
                const hasPermission = getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser);
                return (
                    <div className='relative h-full w-full flex items-center justify-center'>
                        <Icon
                            name='delete'
                            size={1.25}
                            className={`${hasPermission ? 'text-[#000000] cursor-pointer' : 'text-gray-400 cursor-not-allowed'}`}
                            onClick={(e: any) => {
                                e.stopPropagation();
                                e.preventDefault();

                                if (!hasPermission) {
                                    toast.error("You don't have permission to manage checklist controls");
                                    return false;
                                }

                                setSelectedAssets((prev: any) => {
                                    const updatedAssets = prev.filter((asset: any) => asset.assetID !== params.data.assetID);
                                    setSelectedAssets(updatedAssets);
                                    return updatedAssets;
                                });
                                return false;
                            }}
                        />
                    </div>
                );
            },

        }
    ]

    const findAssetsModalRef: any = useRef<any>(null);
    const checklistPreviewModalRef: any = useRef<any>(null);


    const onGridReady = (params: any) => {
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);
    };

    const onRowClicked = (event: any) => {
        if (!event.event.target.closest('input[type="checkbox"]')) {
            event.node.setSelected(false); // Unselect row if it's clicked, not by checkbox
        }
    };

    type formComponentTypes = 'checkbox' | 'text-field' | 'yes-no-na' | 'number-field' | 'inspection' | 'multiple-choice' | 'amount' | 'checklist' | 'picture-file' | 'signature' | 'date' | 'time';

    const [cards, setCards] = useState<any>([]);

    const onDragEnd = (result: any) => {
        if (!result.destination) return;
        const reordered = Array.from(cards);
        const [removed] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, removed);
        setCards(reordered);
    };
    const placeCaretAtEnd = (el: any) => {
        el.focus();

        if (typeof window.getSelection != "undefined" && typeof document.createRange != "undefined") {
            const range = document.createRange();
            range.selectNodeContents(el);
            range.collapse(false); // false = end
            const sel: any = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
        }
    }
    const EditableText = (text: string, onInput: (e: any) => void) => {
        return <p className='outline-none text-[0.9rem] focus:bg-slate-200 leading-6'
            contentEditable
            suppressContentEditableWarning={true}
            onBlur={(e: any) => {
                console.log("ON blur", e.target.innerText);
                onInput(e)
            }}
            onInput={(e: any) => {
                //onInput(e)
                //placeCaretAtEnd(e.target);
            }}
        >{text}</p>;
    }


    const getFormComponent = (card: any) => {
        switch (card.type) {
            case 'checkbox':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}

                    <div className={`flex gap-4 mt-2 ${card.customize ? 'flex-col items-start' : ''}`}>
                        {card.options.map((option: string, index: number) => (
                            <div className='flex gap-2' key={`${card.id}-${index}`}>
                                <input type="checkbox" name={`${card.id}`} value={option} />
                                {card.optionEditable ?
                                    EditableText(option, (e: any) => {
                                        card.options[index] = e.target.innerText;
                                    })
                                    : <p>{option}</p>}
                                {card.customize && <Icon
                                    name="delete"
                                    className="text-red-400 cursor-pointer"
                                    onClick={() => {
                                        card.options.splice(index, 1);
                                        setCards([...cards]);
                                    }}
                                />}
                            </div>
                        ))}
                        {card.customize && <Button theme='secondary' className='mt-2' onClick={() => {
                            card.options.push('Option ' + (card.options.length + 1));
                            setCards([...cards]);
                        }
                        }>Add Option</Button>}
                    </div>
                </div>;
            case 'text':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}

                    <input type="text" name={`${card.id}`} placeholder="Enter text"
                        className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                </div>
            case 'radio':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className={`flex gap-4 mt-2 ${card.customize ? 'flex-col items-start' : ''}`}>
                        {card.options.map((option: string, index: number) => (
                            <div className='flex gap-2' key={`${card.id}-${index}`}>
                                <input type="radio" name={`${card.id}`} value={option} />
                                {card.optionEditable ?
                                    EditableText(option, (e: any) => {
                                        card.options[index] = e.target.innerText;
                                        setCards([...cards]);
                                    })
                                    : <p>{option}</p>}
                                {card.customize && <Icon
                                    name="delete"
                                    className="text-red-400 cursor-pointer"
                                    onClick={() => {
                                        card.options.splice(index, 1);
                                        setCards([...cards]);
                                    }}
                                />}
                            </div>
                        ))}
                        {card.customize && <Button theme='secondary' className='mt-2' onClick={() => {
                            card.options.push('Option ' + (card.options.length + 1));
                            setCards([...cards]);
                        }
                        }>Add Option</Button>}
                    </div>
                </div>
            case 'number':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    {card.component === 'amount' ? <div className='flex items-center gap-2'>
                        <span>$</span><input type="number" name={`${card.id}`} placeholder="Enter Amount" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                    </div>
                        : <input type="number" name={`${card.id}`} placeholder="Enter number" className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] mt-2 pl-2 py-1 font-xs h-[2rem] w-full' />
                    }

                </div>
            case 'file':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <input type="file" name={`${card.id}`} accept="image/*" multiple={card.multiple} />
                </div>
            case 'signature':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='mt-2 border-[#CECECE] border h-[80px] p-3 text-center ' >
                        Assignee will sign here
                    </div>
                </div>
            case 'date':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='flex gap-2 mt-2'>
                        <input type="date" name={`${card.id}`} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' />
                        {/* <input type="time" name={`${card.id}`} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' /> */}
                    </div>
                </div>;
            case 'time':
                return <div>
                    {EditableText(card.label, (e: any) => {
                        card.label = e.target.innerText;
                    })}
                    <div className='flex gap-2 mt-2'>
                        <input type="time" name={`${card.id}`} className='border-[#CECECE] border focus:outline-none focus:primary text-[0.938rem] pl-2 py-1 font-xs h-[2rem] w-full' />
                    </div>
                </div>;
            default:
                return null;
        }
    };

    const inputIDS: formComponentTypes[] = ['checkbox', 'text-field', 'yes-no-na', 'number-field', 'inspection', 'multiple-choice', 'amount', 'checklist', 'picture-file', 'signature', 'date', 'time'];

    const getNewComponent = (formComponent: formComponentTypes) => {
        const ID = 'field_' + (new Date().getTime() + Math.random()).toString();
        let newCard: any = { id: ID, component: formComponent };
        switch (formComponent) {
            case 'checkbox':
                newCard = { ...newCard, type: 'checkbox', label: 'CheckBox', name: ID, options: ['Option 1'], customize: false, optionEditable: true };
                break;
            case 'text-field':
                newCard = { ...newCard, type: 'text', label: 'Text Field', name: ID, placeholder: 'Enter text' };
                break;
            case 'yes-no-na':
                newCard = { ...newCard, type: 'radio', label: 'Yes, No, Not Applicable', name: ID, options: ['Yes', 'No', 'Not Applicable'], customize: false, optionEditable: false };
                break;
            case 'number-field':
                newCard = { ...newCard, type: 'number', label: 'Number Field', name: ID, placeholder: 'Enter number' };
                break;
            case 'inspection':
                newCard = { ...newCard, type: 'radio', label: 'inspection', name: ID, options: ['Pass', 'Fail', 'Flag'], customize: false, optionEditable: false };
                break;
            case 'multiple-choice':
                newCard = { ...newCard, type: 'radio', label: 'Multiple Choice', name: ID, options: ['Option 1', 'Option 2', 'Option 3'], customize: true, optionEditable: true };
                break;
            case 'amount':
                newCard = { ...newCard, type: 'number', label: 'Amount', name: ID, placeholder: 'Enter amount', icon: 'price-change' };
                break;
            case 'checklist':
                newCard = { ...newCard, type: 'checkbox', label: 'Checklist', name: ID, options: ['Item 1', 'Item 2', 'Item 3'], customize: true, optionEditable: true };
                break;
            case 'picture-file':
                newCard = { ...newCard, type: 'file', label: 'Picture/File', name: ID, accept: 'image/*', multiple: true };
                break;
            case 'signature':
                newCard = { ...newCard, type: 'signature', label: 'Signature Block', name: ID };
                break;
            case 'date':
                newCard = { ...newCard, type: 'date', label: 'Date', name: ID, placeholder: 'Select date' };
                break;
            case 'time':
                newCard = { ...newCard, type: 'time', label: 'Time', name: ID, placeholder: 'Select time' };
                break;
            default:
                newCard = null;
        }
        return newCard;
    }

    const getChecklists = async (): Promise<void> => {

        try {
            const resp: any = await new Promise((resolve, reject) => {
                checklistAPI.getChecklists(
                    { checkListIDs: params.id },
                    (r: any) => resolve(r),
                    (e: any) => reject(e)
                );
            });
            setChecklistName(resp?.checklistList?.[0]?.title ?? '');
        } catch (error: any) {
            console.log("error =>", error);
            toast.error(error?.message || 'Failed to load checklist');
        }
    };

    const handelComponentClick = (formComponent: formComponentTypes) => {
        // Check permission before adding components
        if (!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)) {
            toast.error("You don't have permission to manage checklist controls");
            return;
        }

        let newCard: any = getNewComponent(formComponent);
        if (newCard) {
            setCards([...cards, newCard]);
        } else {
            console.error('Unknown component type');
        }
    };

    const saveChecklistTasks = () => {
        if (!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)) {
            toast.error(`Unauthorized attempt: ${"Manage Checklist Controls"}`);
            return;
        } else {
            let payload: any = {
                "checkListID": Number(params.id),
                "tasks": []
            }

            cards.forEach((card: any, i: number) => {
                let taskType: formComponentTypes = card.component;
                let task: any = {
                    "CheckListID": 1, // This should be dynamic based on your checklist ID
                    "Title": card.label || 'New Task',
                    "InputLabel": card.label || 'Task Label',
                    "InputTypeID": 0, // This will be set based on the task type
                    "IsRequired": true,
                    "SortOrder": i + 1, // This can be set based on the order of the task
                }
                if (card.checkListTaskID) {
                    task.checkListTaskID = card.checkListTaskID
                }

                switch (taskType) {
                    case 'checkbox':
                        task = {
                            ...task,
                            "InputTypeID": 1,
                            "IsRequired": true,
                            "CheckBoxOptions": card.options.map((option: string) => {
                                return {
                                    "CheckboxName": option,
                                    "IsChecked": false
                                }
                            })
                        }
                        break;
                    case 'text-field':
                        task = {
                            ...task,
                            "InputTypeID": 2,
                            "IsRequired": true,
                            "TextResponse": ""
                        }
                        break;
                    case 'yes-no-na':
                        task = {
                            ...task,
                            "InputTypeID": 3,
                            "IsRequired": false,
                            "YesNoOption": null
                        }
                        break;
                    case 'number-field':
                        task = {
                            ...task,
                            "InputTypeID": 4,
                            "IsRequired": true,
                            "NumberValue": 0
                        }
                        break;
                    case 'inspection':
                        task = {
                            ...task,
                            "InputTypeID": 5,
                            "IsRequired": true,
                            "InspectionStatus": null // This can be 'Pass', 'Fail', or 'Flag'
                        }
                        break;
                    case 'multiple-choice':
                        task = {
                            ...task,
                            "InputTypeID": 6,
                            "IsRequired": true,
                            "CheckBoxOptions": card.options.map((option: string) => ({
                                CheckboxName: option,
                                IsChecked: false
                            }))
                        }
                        break;
                    case 'amount':
                        task = {
                            ...task,
                            "InputTypeID": 7,
                            "IsRequired": false,
                            "Amount": 0
                        }
                        break;
                    case 'checklist':
                        task = {
                            ...task,
                            "InputTypeID": 8,
                            "IsRequired": false,
                            "CheckBoxOptions": card.options.map((option: string) => ({
                                CheckboxName: option,
                                IsChecked: false
                            }))
                        }
                        break;
                    case 'picture-file':
                        task = {
                            ...task,
                            "InputTypeID": 9,
                            "IsRequired": false,
                        }
                        break;
                    case 'signature':
                        task = {
                            ...task,
                            //"CheckListTaskID": 10,
                            "InputTypeID": 10,
                            "IsRequired": true,
                        }
                        break;
                    case 'date':
                        task = {
                            ...task,
                            //"CheckListTaskID": 11,
                            "InputTypeID": 11,
                            "IsRequired": false,
                            "DateValue": null//moment().format(DATE_FORMAT)
                        }
                        break;
                    case 'time':
                        task = {
                            ...task,
                            //"CheckListTaskID": 11,
                            "InputTypeID": 12,
                            "IsRequired": false,
                            "DateValue": null//moment().format(DATE_FORMAT)
                        }
                        break;

                    default:
                        break;
                }

                payload.tasks.push(task);
            });
            console.log('Cards', cards);
            console.log('payload', payload);
            //return;

            checklistAPI.saveChecklistTask(payload, (resp: any) => {
                if (selectedAssets && selectedAssets.length > 0) {

                    checklistAPI.saveCheckListTasksAssetMapping({
                        "checkAsset": selectedAssets.map((asset: any) => ({
                            "checkListID": Number(params.id),
                            "assetID": asset.assetID
                        })),
                    }, (resp: any) => {

                        console.log('Checklist tasks saved successfully:', resp);
                        toast.success('Checklist tasks saved successfully');
                        navigate(URLS.CHECKLISTS);
                    }, (error: any) => {
                        console.error('Error saving checklist tasks assets:', error);
                        toast.error('Error saving checklist tasks assets');
                    });
                } else {
                    console.log('Checklist tasks saved successfully:', resp);
                    toast.success('Checklist tasks saved successfully');
                    navigate(URLS.CHECKLISTS);
                }

            }, (error: any) => {
                console.error('Error saving checklist tasks:', error);
                toast.error('Error saving checklist tasks');
            })
        }
    }

    const getChecklistByID = () => {
        let payload: any = {
            "checkListID": Number(params.id)
        }
        checklistAPI.getChecklistByID(payload, (resp: any) => {
            console.log('get tasks ----> ', resp.tasks);
            let _cards: any = [];
            resp.tasks.forEach((task: any) => {
                let formComponent: formComponentTypes = inputIDS[task.inputTypeID - 1];
                console.log('formComponent', formComponent);
                let newCard: any = getNewComponent(formComponent);
                newCard.label = task.inputLabel;
                newCard.checkListTaskID = task.checkListTaskID; // Assuming checkListTaskID is unique
                newCard.sortOrder = task.sortOrder;
                if (newCard) {
                    switch (formComponent) {
                        case 'checkbox':
                            newCard.options = task.checkBoxOptions.map((option: any) => option.checkboxName);
                            break;
                        case 'multiple-choice':
                        case 'checklist':
                            newCard.options = task.checkBoxOptions.map((option: any) => option.checkboxName);
                            break;
                            break
                    }


                    _cards.push(newCard);
                }
            });
            console.log('Cards from API:', _cards);
            setCards(_cards);
        }, (error: any) => {

        })

    }
    const getAssetsByChecklist = () => {
        let payload: any = {
            "checkListID": Number(params.id)
        }
        checklistAPI.getAssetsByChecklist(payload, (resp: any) => {
            console.log('get assets ----> ', resp.assetList);
            setSelectedAssets(resp.assetList)
            /* let _cards:any = [];
            resp.tasks.forEach((task: any) => {
                let formComponent: formComponentTypes = inputIDS[task.inputTypeID - 1];
                console.log('formComponent', formComponent);
                let newCard: any = getNewComponent(formComponent);
                newCard.label = task.inputLabel;
                newCard.checkListTaskID = task.checkListTaskID; // Assuming checkListTaskID is unique
                if (newCard) {
                    switch (formComponent) {
                        case 'checkbox':
                            newCard.options = task.checkBoxOptions.map((option: any) => option.checkboxName);
                            break;
                        case 'multiple-choice': 
                        case 'checklist': 
                            newCard.options = task.checkBoxOptions.map((option: any) => option.checkboxName);
                            break;
                        break
                    }


                    _cards.push(newCard);
                }
            }); */
            //setCards(_cards);
        }, (error: any) => {

        })

    }

    useEffect(() => {
        getChecklists();
        getChecklistByID();
        getAssetsByChecklist();
    }, []);
    useEffect(() => {
        console.log('Cards updated:', cards);
    }, [cards]);




    return (
        <Layout>
            <div className='flex flex-col h-full'>
                <Header title={checklistName} back="/checklists">
                    <Header.Right>
                        <Button theme='secondary' onClick={() => { checklistPreviewModalRef?.current?.showModal() }}>Preview</Button>
                        <Button disabled={!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)} onClick={saveChecklistTasks} >Save</Button>
                    </Header.Right>
                </Header>


                <div>
                    <div className="accordion">
                        <div className="accordion-item border border-t-0 border-gray-200 rounded">
                            <div className="flex justify-between accordion-header p-4 cursor-pointer"                            >
                                <h3 className="font-semibold" onClick={() => setAssetInfoShow(!assetInfoShow)}>Associate with an Asset</h3>
                                <div className='flex items-center gap-2'>
                                    {assetInfoShow && <Button
                                        size='sm'
                                        theme='dark'
                                        disabled={!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)}
                                        onClick={() => {
                                            if (!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)) {
                                                toast.error("You don't have permission to manage checklist controls");
                                                return;
                                            }
                                            findAssetsModalRef?.current?.showModal();
                                        }}
                                    >
                                        Associate with an Asset
                                    </Button>}
                                    <div onClick={() => setAssetInfoShow(!assetInfoShow)}>
                                        <Icon name={assetInfoShow ? 'arrowup' : 'arrowdown'} size={1.25} />
                                    </div>
                                </div>
                            </div>
                            {assetInfoShow && (
                                <div className="accordion-body py-2">
                                    <div className="ag-theme-alpine mx-4  h-1/2">
                                        <AgGridReact
                                            columnDefs={columnDefs} // Pass columnDefs
                                            rowData={selectedAssets || []} // Pass rowData
                                            pagination={false}
                                            rowSelection="multiple"
                                            onGridReady={onGridReady}
                                            domLayout="autoHeight"
                                            onRowClicked={onRowClicked}
                                            loadingOverlayComponent={Loader}
                                            noRowsOverlayComponent={() => (
                                                <div className="flex items-center justify-center h-full">
                                                    <div className="text-center text-gray-500">
                                                        <div className="text-lg font-medium">No Data Found</div>
                                                    </div>
                                                </div>
                                            )}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='flex-grow flex relative'>
                    <div className='shrink-0 w-[280px] p-3 '>
                        <label htmlFor="">Form Components</label>
                        <p className='text-sm text-gray-600'>Click here to add</p>
                        <div className='grid grid-cols-2 gap-2 mt-2 text-center text-[0.6rem] '>
                            {/* {
                                formComponents.map((component) => (
                                    <div key={component.id} className='rounded shadow p-2 border' onClick={() => handelComponentClick(component.id)}>
                                        <div><Icon name={`${component.icon}`} /></div>
                                        <div>{component.title}</div>
                                    </div>
                                ))
                            } */}
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('text-field')}>
                                <div ><Icon name='text-field' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Text Field</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('number-field')}>
                                <div ><Icon name='number' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Number Field</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('amount')}>
                                <div ><Icon name='price-change' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Amount</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('date')}>
                                <div ><Icon name='calendar' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Date</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('time')}>
                                <div ><Icon name='clock' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Time</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('yes-no-na')}>
                                <div ><Icon name='thumbs-up' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Yes, No</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('inspection')}>
                                <div ><Icon name='inspection' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Inspection</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('checkbox')}>
                                <div ><Icon name='checkbox' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Checkbox</div>
                            </div>

                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('checklist')}>
                                <div ><Icon name='checklist' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Checklist</div>
                            </div>


                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('multiple-choice')}>
                                <div ><Icon name='multiple-checkbox' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Multiple Choice</div>
                            </div>


                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('picture-file')}>
                                <div ><Icon name='image' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Picture/File</div>
                            </div>
                            <div className={`rounded shadow p-2 border flex flex-col items-center ${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'cursor-pointer hover:bg-gray-50' : 'cursor-not-allowed opacity-50'}`} onClick={() => handelComponentClick('signature')}>
                                <div ><Icon name='signature' size={1.5} /></div>
                                <div className='text-[0.8rem]'>Signature Block</div>
                            </div>


                        </div>
                    </div>
                    <div className='grow bg-gray-100 max-h-full overflow-y p-2  '>

                        <div className=''>
                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="checklist-cards p-5">
                                    {(provided) => (
                                        <div {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className="flex flex-col gap-1 p-3"
                                        >
                                            {cards.map((card: any, index: number) => (
                                                <Draggable key={card.id} draggableId={card.id} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={`flex bg-white rounded shadow p-2 border ${snapshot.isDragging ? 'border-primary' : 'border-gray-200'
                                                                }`}
                                                        >
                                                            <div className='flex  justify-between items-center w-full pr-5 cursor-default'>
                                                                <div className='flex items-center'>
                                                                    <Icon name='grid' className='cursor-move' />
                                                                    <div className="text-sm ml-2 cursor-default">
                                                                        {getFormComponent(card)}
                                                                    </div>
                                                                </div>

                                                                <Icon
                                                                    name='delete'
                                                                    className={`${getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser) ? 'text-red-400 cursor-pointer' : 'text-gray-400 cursor-not-allowed'} ml-auto`}
                                                                    onClick={() => {
                                                                        if (!getPermissionInfo(location.pathname, "Manage Checklist Controls", loggedinuser)) {
                                                                            toast.error("You don't have permission to manage checklist controls");
                                                                            return;
                                                                        }

                                                                        const updatedCards = cards.filter((c: any) => c.id !== card.id);
                                                                        setCards(updatedCards);
                                                                    }}
                                                                />

                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                            {
                                cards.length === 0 && (
                                    <div className='text-center text-gray-500 mt-10'>
                                        No components added yet. Click on a component to add it to the checklist.
                                    </div>
                                )
                            }

                        </div>
                    </div>

                </div>
            </div>
            <FindAssetsModal _ref={findAssetsModalRef} onSelect={setSelectedAssets} selected={selectedAssets} />
            <ChecklistPreviewModal _ref={checklistPreviewModalRef} cards={cards} />
        </Layout>
    );
};

export default ChecklistFormCreate;